import React from 'react';
import { Wrapper } from './ValidationMessage.styles';

const ValidationMessage = ({show, children}: { children: any, show: boolean}) => {
    if (!show) return <></>;
    return <Wrapper className="validation">{children}</Wrapper>
}

export default ValidationMessage;
